import { computed } from 'vue'
import {each} from "lodash-es";

export function useScore (game) {
    const score = computed(() => {
        if (game.sport_id === 50) {
            return game.score.GOAL
        }
        if ([51, 53].includes(game.sport_id)) {
            return game.score.T
        }
        if (game.sport_id === 54) {
            let score = [0, 0]
            each(game.score, (s) => {
                if (s[0] >= 25 && s[0] - 2 >= s[1]) {
                    score[0] = score[0] += 1
                }
                if (s[1] >= 25 && s[1] - 2 >= s[0]) {
                    score[1] = score[1] += 1
                }
            })
            return score
        }
        if (game.sport_id === 56) {
            return game.score.R
        }
        if (game.sport_id === 95) {
            return game.score.mapscore
        }
        return null
    })

    return {
        score
    }
}
